<div class="landing-page centered-heading">
  <div class="content">
    <h1 class="title">{{ 'home.title' | translate }}</h1>
    <div class="centered-paragraph p">
      <p>{{ 'home.intro' | translate }}</p>
      <p>{{ 'home.benefits' | translate }}</p>
      <p>{{ 'home.uiStructure' | translate }}</p>
    </div>
  </div>
</div>
<div class="cards-container">
  <div class="card">
    <p class="card-text"><strong>{{ 'home.roles' | translate }}</strong></p>
    <ul>
      <li class="text">{{ 'home.productOwner' | translate }}: Ulrich Binswanger</li>
      <li class="text">{{ 'home.solutionArchitect' | translate }}: Florian Fischer</li>
      <li class="text">{{ 'home.developers' | translate }}: Kai Schuhmacher (Exxeta), Sascha Ercevic
        (Exxeta), Yannick Kor (Exxeta), Sascha Kuhn (Exxeta)
      </li>
      <li class="text">{{ 'home.testing' | translate }}: Mesut Yildiz (Exxeta)</li>
    </ul>

    <p class="card-text"><strong>{{ 'home.contactUs' | translate }}</strong></p>
    <li class="text" style="margin-left: 20px">{{ 'home.slackChannel' | translate }}: <a
        href="https://enpower-me.slack.com/archives/G01DXGEPL3V" target="_blank">Roaming
      Team</a></li>

  </div>
  <div class="card">
    <p class="card-text"><strong>{{ 'home.purpose' | translate }}</strong></p>
    <ul>
      <li class="text">{{ 'home.purposeDescription1' | translate }}</li>
      <li class="text">{{ 'home.purposeDescription2' | translate }}</li>
    </ul>
  </div>
  <div class="card">
    <p class="card-text"><strong>{{ 'home.responsibilities' | translate }}</strong></p>
    <ul>
      <li class="text">{{ 'home.responsibility1' | translate }}</li>
      <li class="text">{{ 'home.responsibility2' | translate }}</li>
      <li class="text">{{ 'home.responsibility3' | translate }}</li>
      <li class="text">{{ 'home.responsibility4' | translate }}</li>
      <li class="text">{{ 'home.responsibility5' | translate }}</li>
      <li class="text">{{ 'home.responsibility6' | translate }}</li>
    </ul>
  </div>
</div>
